import {
  FiFileText,
  FiHelpCircle,
  FiInbox,
  FiLayers,
  FiLogOut,
  FiRefreshCw,
  FiSettings,
  FiCheckSquare,
  FiUsers,
} from "react-icons/fi";

import iconMoodle from "./icon-moodle.svg";
import iconTeams from "./icon-teams.svg";
import "./Menu.css";
import { useContext } from "react";
import { UserContext } from "../userContext";
import { useTranslation } from "react-i18next";

export default function Menu() {
  const user = useContext(UserContext);
  const { t, i18n } = useTranslation("common");

  if (!user) return <></>;

  return (
    <div className="position-sticky pt-3">
      <ul className="nav flex-column">
        <li className="nav-item">
          <a href="/my-courses" className="nav-link">
            <FiRefreshCw />
            {t("menu.curriclarTitle")}
          </a>
          <a href="/courses-manual" className="nav-link">
            <FiInbox />
            {t("menu.manualTitle")}
          </a>
        </li>
        {user.role == "admin" && (
          <>
            <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>{t("menu.adminHeadline")}</span>
            </h6>
            <li className="nav-item">
              <a href="/courses-admin" className="nav-link">
                <FiLayers /> {t("menu.newMoodleCoursesTitle")}
              </a>
            </li>
            <li className="nav-item">
              <a href="/completed-courses-admin" className="nav-link">
                <FiCheckSquare /> {t("menu.completedMoodleCoursesTitle")}
              </a>
            </li>
            <li className="nav-item">
              <a href="/teams-sync-status" className="nav-link">
                <FiRefreshCw /> Teams Sync Status
              </a>
            </li>
          </>
        )}
        <hr />
        <li className="nav-item">
          <a href="/info" className="nav-link">
            <FiHelpCircle /> {t("menu.infoTitle")}
          </a>
        </li>
      </ul>
      {user.role == "admin" && (
        <>
          <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>{t("menu.settingsHeadline")}</span>
          </h6>
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              <a href="/settings" className="nav-link">
                <FiSettings /> {t("menu.settingsGeneralTitle")}
              </a>
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
